// extracted by mini-css-extract-plugin
export default {"box":"Variants_box__CQscN","title":"Variants_title__HekXk","variants":"Variants_variants__En5T7","variant":"Variants_variant__Qk5C1"};